<script setup lang="ts">
import MessagePlain from '@/views/chat/components/message-plain.vue'
import CbTable from '@/components/cb-table.vue'
import { computed, ref } from 'vue'
import { sendEmailApi } from '@/api/chatApi'
import { showToast } from '@nutui/nutui'
import type { ResponseMessageTType, IResponseTableType } from '@/types'
import { useMessageComponent } from '@/views/chat/components/composition'
//import { fi } from 'vuetify/locale'

const props = defineProps<{ data: ResponseMessageTType<IResponseTableType> }>()
const emit = defineEmits(['send'])

const { plainAttrs } = useMessageComponent(props.data)
const loading = ref(false)

const showEmail = computed(() => {
  if (!props.data.tableResponse.isSendMail) {
    return false
  }
  const time = +new Date() - props.data.timestamp! - 48 * 3600 * 1000
  return time < 0
})

const canSend = computed(() => {
  if (loading.value) {
    return false
  }
  return !props.data.tableResponse.sent
})

const columns = computed(() => {
  const header = props.data?.tableResponse.columnHeader || {}
  const alignment = props.data?.tableResponse.columnAlignment||{}
  return (
    props.data?.tableResponse.columns.map((field) => {
      return {
        field,
        title: header[field],
        align:alignment[field]
      }
    }) || []
  )
})

const list = computed(() => {
  return props.data?.tableResponse.data || []
})

async function handleSendEmail() {
  if (!canSend.value) {
    return
  }
  loading.value = true
  await sendEmailApi(props.data.responseId).catch((e) => {
    switch (e.code) {
      case 'ERR_NETWORK':
        showToast.text('网络错误')
        break
      case 'ECONNABORTED':
        showToast.text('网络超时')
        break
    }
    loading.value = false
    return Promise.reject(e)
  })
  emit('send')
  loading.value = false
}
</script>

<template>
  <message-plain
    v-bind="plainAttrs"
    class="message-guess font-3"
    :content="data.tableResponse.description"
  >
    <template #details>
      <cb-table :columns="columns" :data="list" />
      <a
        v-if="showEmail"
        :class="{ disabled: !canSend }"
        class="send-button"
        @click="handleSendEmail"
      >
        全量数据发送邮箱
      </a>
    </template>
  </message-plain>
</template>

<style scoped lang="scss">
.cb-table {
  margin-top: 0.547rem;
}

.send-button {
  margin-top: 0.48rem;
  font-size: 0.493rem;
  display: inline-block;
  color: #fff;
  background-color: var(--primary-color);
  border-radius: 10rem;
  line-height: 1.16rem;
  padding: 0 0.4rem;

  &.disabled {
    background-color: #bbb;
  }
}
</style>
